import React from 'react'
import { Spacer, Text, View } from 'oio-react'
import PropTypes from 'prop-types'

// TODO: Remove lint
// eslint-disable-next-line arrow-body-style
const OrderSummary = ({ discounts, loading, orderTotals }) => {
   // const discountCodes = discounts.map(discount => discount.code)

   return (
      <View
         backgroundColor={loading ? '#ccffff' : '#edf7f7'}
         padding="24px[a] 30px[b-f]"
         borderRadius="6px">
         <Text size="2" weight="medium">Order Summary</Text>
         <Spacer size="2" />
         <View
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            padding="6px 0px"
            borderTop="1px solid rgba(0,0,0,0.1)">
            <Text size="2" color="rgba(0,0,0,0.7)">
               Subtotal
            </Text>
            <Text size="3" color="rgba(0,0,0,0.7)">
               {orderTotals.subtotal.toLocaleString('en-US', {
                  style: 'currency',
                  currency: 'USD'
               })}
            </Text>
         </View>
         {orderTotals.taxes.map(tax => (
            <View
               display="flex"
               justifyContent="space-between"
               alignItems="center"
               padding="6px 0px"
               borderTop="1px solid rgba(0,0,0,0.1)">
               <Text size="2" color="rgba(0,0,0,0.7)">
                  {tax.name}
               </Text>
               <Text size="3" color="rgba(0,0,0,0.7)">
                  {tax.amount.toLocaleString('en-US', {
                     style: 'currency',
                     currency: 'USD'
                  })}
               </Text>
            </View>
         ))}
         <View
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            padding="6px 0px"
            borderTop="1px solid rgba(0,0,0,0.1)">
            <Text size="3" weight="medium">
               Total
            </Text>
            <Text size="5" weight="medium">
               {orderTotals.total.toLocaleString('en-US', {
                  style: 'currency',
                  currency: 'USD'
               })}
            </Text>
         </View>
      </View>
   )
}

OrderSummary.propTypes = {
   discounts: PropTypes.array,
   loading: PropTypes.bool,
   orderTotals: PropTypes.object.isRequired
}

OrderSummary.defaultProps = {
   discounts: [],
   loading: false
}

export default OrderSummary
